import ListRecommended from './list-recommended'

export default ListRecommended
